import {ExitToAppOutlined} from '@mui/icons-material';
import {MenuItem, Typography} from '@mui/material';
import {AuthService} from '@services/AuthService';
import styles from '../Header.module.scss';
import {useTranslation} from 'react-i18next';

type LogoutProps = {afterLogout?: () => void};

export const Logout = ({afterLogout}: LogoutProps) => {
    const {t} = useTranslation('header');
    const onLogoutClick = () => {
        AuthService.logout();
        afterLogout?.();
    };

    return (
        <MenuItem
            onClick={() => onLogoutClick()}
            className={styles.menuItem}
        >
            <ExitToAppOutlined sx={{mr: 1}} />
            <Typography>{t('exit')}</Typography>
        </MenuItem>
    );
};
